
export default {
  name: 'ComponentModal',
  props: {
    width: {
      type: String,
      default: '940px',
    },
    height: {
      type: String,
      default: '600px',
    },
    padding: {
      type: String,
      default: '20px',
    },
    borderRadius: {
      type: String,
      default: '16px',
    },
  },
  computed: {
    style() {
      return {
        width: this.width,
        height: this.height,
        padding: this.padding,
        borderRadius: this.borderRadius,
      }
    },
  },
}
